import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, o as objectWithoutPropertiesLoose} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {T as Typography} from "../../common/index-6e985b71.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import {d as dialogTitleClasses_1} from "../../common/dialogTitleClasses-1a3b51c9.js";
import {D as DialogContext_1} from "../../common/DialogContext-15c94dab.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/capitalize-0607751a.js";
var DialogTitle_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _Typography = interopRequireDefault(Typography);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _DialogContext = interopRequireDefault(DialogContext_1);
  const _excluded = ["className", "id"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes
    } = ownerState;
    const slots = {
      root: ["root"]
    };
    return (0, core.unstable_composeClasses)(slots, dialogTitleClasses_1.getDialogTitleUtilityClass, classes);
  };
  const DialogTitleRoot = (0, _styled.default)(_Typography.default, {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles) => styles.root
  })({
    padding: "16px 24px",
    flex: "0 0 auto"
  });
  const DialogTitle2 = /* @__PURE__ */ React$1.forwardRef(function DialogTitle3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiDialogTitle"
    });
    const {
      className,
      id: idProp
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const {
      titleId: id = idProp
    } = React$1.useContext(_DialogContext.default);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogTitleRoot, (0, _extends2.default)({
      component: "h2",
      className: (0, _clsx.default)(classes.root, className),
      ownerState,
      ref,
      variant: "h6",
      id
    }, other));
  });
  var _default = DialogTitle2;
  exports.default = _default;
});
var DialogTitle = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    dialogTitleClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _DialogTitle.default;
    }
  });
  Object.defineProperty(exports, "dialogTitleClasses", {
    enumerable: true,
    get: function() {
      return _dialogTitleClasses.default;
    }
  });
  var _DialogTitle = interopRequireDefault(DialogTitle_1);
  var _dialogTitleClasses = _interopRequireWildcard(dialogTitleClasses_1);
  Object.keys(_dialogTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _dialogTitleClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _dialogTitleClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(DialogTitle);
export default __pika_web_default_export_for_treeshaking__;
